import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import SentrySplashScreen from './SentrySplashScreen';
import SentryWalletConnectionScreen from './SentryWalletConnectionScreen';

type FlowStage = 'splash' | 'wallet-connection';

const DesktopCenterWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #000000;

  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
`;

const SentryPWAEntryFlow: React.FC = () => {
  const [stage, setStage] = useState<FlowStage>('splash');
  const navigate = useNavigate();

  useEffect(() => {
    if (stage === 'splash') {
      const timer = setTimeout(() => {
        setStage('wallet-connection');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [stage]);

  const handleProceedToApp = () => {
    navigate('/sentry-pwa/tokens');
  };

  const handleProceedToAgent = () => {
    navigate('/sentry-agent/wallet');
  };

  if (stage === 'splash') {
    return (
      <DesktopCenterWrapper>
        <SentrySplashScreen />
      </DesktopCenterWrapper>
    );
  }

  return (
    <DesktopCenterWrapper>
      <SentryWalletConnectionScreen onProceed={handleProceedToApp} onAgentProceed={handleProceedToAgent} />
    </DesktopCenterWrapper>
  );
};

export default SentryPWAEntryFlow;
